module.exports = __webpack_public_path__ + "static/9001-782cbd33a2b1a49f81690ebe1daec3f9.svg";